import { render } from "./PlanningPage.vue?vue&type=template&id=5f636db8"
import script from "./PlanningPage.vue?vue&type=script&lang=js"
export * from "./PlanningPage.vue?vue&type=script&lang=js"

import "./PlanningPage.vue?vue&type=style&index=0&id=5f636db8&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__